// Framework-free geometry of the Yakoot mark (design package 2026-10-20, direction "Club"): a faceted ruby gem with a
// Y-shaped cut-out. Rebuilt from design/handover-2026-10-20/assets/logo/svg/yakoot-mark-*.svg. Used by the web
// components here and by the React Native version in the mobile repo (react-native-svg).
//
// Coordinates are on the 822 × 822 master grid; the master SVG places that grid inside a 1000 × 1000 viewBox with
// `translate(20.48 22.80) scale(1.16248)`. MARK_TRANSFORM reproduces that so a 1000-unit viewBox maps 1:1 to the PNGs.
export const MARK_VIEWBOX = 1000;
export const MARK_GRID = 822;
export const MARK_TRANSFORM = 'translate(20.48 22.80) scale(1.16248)';
/** Outer gem outline. */
export const MARK_OUTER_PATH = 'M206 66 H615 L791 300 L434 755 H391 L34 300 Z';
/** The Y counter (true cut-out: the mark sits on any background). */
export const MARK_INNER_PATH = 'M265 193 L410 337 L556 193 L619 280 L483 450 L431 755 H394 L334 450 L201 280 Z';
/** Outer minus inner as a single evenodd path, for flat (white / mono / flat-ruby) variants. */
export const MARK_FLAT_PATH = `${MARK_OUTER_PATH} ${MARK_INNER_PATH}`;
/** Facets of the colour mark, drawn over a ruby base and clipped to the gem silhouette. */
export const MARK_FACETS = [
    { points: '206,66 410,66 300,210', fill: '#EC3455' },
    { points: '410,66 615,66 520,210', fill: '#EB3354' },
    { points: '300,210 410,66 520,210 410,220', fill: '#BD1535' },
    { points: '300,210 520,210 410,337', fill: '#991126' },
    { points: '206,66 300,210 201,280 160,240', fill: '#F8A5B3' },
    { points: '615,66 660,240 619,280 520,210', fill: '#F79DAD' },
    { points: '206,66 160,240 34,300', fill: '#E4304E' },
    { points: '615,66 791,300 660,240', fill: '#E4304E' },
    { points: '34,300 160,240 201,280 334,450 391,755', fill: '#C50A2E' },
    { points: '791,300 660,240 619,280 483,450 434,755', fill: '#C50A2E' },
    { points: '201,280 265,193 300,210 410,337 334,450', fill: '#D11C3E' },
    { points: '619,280 556,193 520,210 410,337 483,450', fill: '#D11C3E' },
    { points: '334,450 394,755 391,755 300,560', fill: '#A0102A' },
    { points: '483,450 434,755 431,755 520,560', fill: '#A0102A' },
];
/** Brand hexes the mark is drawn with. These are the mark's own colours, not UI tokens. */
export const MARK_COLORS = {
    ruby: '#C8102E',
    ink: '#15171A',
    black: '#000000',
    white: '#FFFFFF',
    /** Latin wordmark colour on light surfaces. */
    latinGrey: '#6E6A64',
    /** Latin wordmark colour on ink surfaces. */
    latinOnInk: 'rgba(255,255,255,0.6)',
};
/** Fill for the flat variants (the colour variant draws facets instead). */
export function markFlatFill(variant) {
    return variant === 'white' ? MARK_COLORS.white : variant === 'mono' ? MARK_COLORS.ink : MARK_COLORS.ruby;
}
/** Logo rules from the design package. */
export const LOGO_RULES = {
    /** Space between mark and wordmark in the horizontal lockup, as a fraction of the mark size. */
    lockupGap: 0.3,
    /** Clear space on all sides = the height of the Y notch, roughly 0.25 × the mark height. */
    clearSpace: 0.25,
    minMarkPx: 16,
    minHorizontalLockupPx: 96,
    /** QR centre badge: round white badge with the colour mark inside (design: 46 px round). */
    qrBadge: { size: 46, radius: 23, markSize: 28 },
    /** App icon: ruby mark on a charcoal rounded square. */
    appIcon: { background: '#15171A', radius: 0.22, markScale: 0.56 },
    arabicWordmark: 'ياقوت',
    latinWordmark: 'yakoot',
    arabicFont: "'IBM Plex Sans Arabic', 'IBM Plex Sans', sans-serif",
    latinFont: "'IBM Plex Sans', sans-serif",
    wordmarkWeight: 600,
};
/** Full SVG markup string (for favicons, emails, or anywhere React is unavailable). */
export function markSvg(variant = 'color', size = 48) {
    const open = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${MARK_VIEWBOX} ${MARK_VIEWBOX}" aria-hidden="true">`;
    if (variant !== 'color') {
        return `${open}<g transform="${MARK_TRANSFORM}"><path fill-rule="evenodd" fill="${markFlatFill(variant)}" d="${MARK_FLAT_PATH}"/></g></svg>`;
    }
    const id = `ykt-mark-clip`;
    const facets = MARK_FACETS.map((f) => `<polygon points="${f.points}" fill="${f.fill}"/>`).join('');
    return `${open}<defs><clipPath id="${id}" clip-rule="evenodd"><path fill-rule="evenodd" clip-rule="evenodd" d="${MARK_FLAT_PATH}"/></clipPath></defs><g transform="${MARK_TRANSFORM}"><g clip-path="url(#${id})"><rect width="${MARK_GRID}" height="${MARK_GRID}" fill="${MARK_COLORS.ruby}"/>${facets}</g></g></svg>`;
}
//# sourceMappingURL=mark.js.map